module.exports = __webpack_public_path__ + "static/img/gptsyfl@2x.6bebc79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ym/gptsyfl@2x.png
// module id = 5B9h
// module chunks = 1